import React from "react";
import { Box, Collapse, Grid, Link } from "@material-ui/core";
import { CustomSelectArrow } from "../../../../../../assets/icons/custom-svg-components/CompanySvgCollection";
import DOMPurify from "dompurify";
import { Utils } from "../../../../../../services/utils";
import "../../../../../../pages/core/pinboard/Pinboard.scss";

interface PinboardTextProps {
  content: string;
  float?: "left" | "right";
}

export const PinboardText: React.FC<PinboardTextProps> = (props) => {
  const [checked, setChecked] = React.useState(false);
  const direction = props.float ? props.float : "left";

  const handleChange = () => {
    setChecked((prev) => !prev);
  };

  let html = DOMPurify.sanitize(
    Utils.convertRteStateToHtml(Utils.convertJsonToRteState(props.content))
  );

  return html === "<p><br></p>" ? (
    <></>
  ) : (
    <>
      <Collapse in={checked} collapsedSize={100}>
        <Box
          style={{ margin: "0.62rem", float: direction }}
          dangerouslySetInnerHTML={{
            __html: html.replaceAll(
              /<a[\s]+([^>]+)>((?:.(?!<\/a>))*.)<\/a>/g,
              "<a $1 onclick=\"if (!this.href.includes('mindlane.de')) return confirm('" +
                "Hinweis: Externe Links unterliegen der Haftung der jeweiligen Betreiber.\\n\\n" +
                "Möchten Sie folgende Webseite öffnen?\\n' + this.href)" +
                '" target="_blank">$2</a>'
            ),
          }}
        />
      </Collapse>

      <Grid container style={{ marginBottom: props.float ? "-1.25rem" : "-1.87rem" }}>
        <Grid item xs={12}>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Link onClick={handleChange} className={"pinboard-post-details-icon"}>
              {checked ? (
                <CustomSelectArrow className={"pinboard-post-shrink-icon"} />
              ) : (
                <CustomSelectArrow className={"pinboard-post-expand-icon"} />
              )}
            </Link>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default PinboardText;
